import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'
/**
 * 查询历史运行数据分页
 * @param params
 */
export function findMonitorHistory(params) {
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/history/findmonitor',
        method: 'get',
        params
    })
}

/**
 * 查询项目列表
 * @param params
 */
export function getProjectList() {
    return request({
        url: envInfo.bgApp.basePath + `/tenant/project/list`,
        method: 'get',
    })
}

/**
 * 查询位置树
 */
export function getPositionTree(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/position/findPositionTree',
        method: 'get',
        params
    })
}

/**
 * 查询设备列表
 */
export function getDeviceList(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/device/list?positionId='+params.positionId,
        method: 'get',
    })
}

/**
 * 查询点位列表
 */
export function getMonitorList(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/monitor/list?deviceId='+params.deviceId,
        method: 'get',
    })
}

/**
 * 导出点位数据
 *
 * @param params
 */
export function exportPoint(params) {
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/history/exportData',
        method: 'post',
        data: params
    })
}

/**
 * 查询点位实时值
 *
 * @param params
 */
export function findPointList(params) {
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/pointcache/codeValue',
        method: 'post',
        data: params
    })
}
